import { ActionType } from '../../constants/ActionTypes'

export default function responsibleGamingReducer(state = {}, action = {}) {

    switch (action.type) {

        case ActionType.GET_NOTIFICATION_PREFERENCES_BEGIN:
            return {
                ...state,
                isLoading: true,
                notificationPreferences: null
            }
        case ActionType.GET_NOTIFICATION_PREFERENCES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                notificationPreferences: action.payload
            }
        case ActionType.GET_NOTIFICATION_PREFERENCES_RULES_BEGIN:
            return {
                ...state,
                isLoading: true,
                notificationPreferencesRules: null
            }
        case ActionType.GET_NOTIFICATION_PREFERENCES_RULES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                notificationPreferencesRules: action.payload
            }
        case ActionType.GET_DORMANT_CODE_BEGIN:
            return {
                ...state,
                dormantCodeLoading: true,
            }
        case ActionType.GET_DORMANT_CODE_SUCCESS:
        case ActionType.GET_DORMANT_CODE_ERROR:
            return {
                ...state,
                dormantCodeLoading: false,
            }
        case ActionType.ACCOUNT_CLOSURE_BEGIN:
            return {
                ...state,
                isSaving: true
            }
        case ActionType.ACCOUNT_CLOSURE_SUCCESS:
        case ActionType.ACCOUNT_CLOSURE_ERROR:
            return {
                ...state,
                isSaving: false
            }
        case ActionType.GET_TIME_LIMIT_BEGIN:
            return {
                ...state,
                timeLimits: {
                    ...state.timeLimits,
                    timeLimitLoading: true,
                }
            }
        case ActionType.GET_TIME_LIMIT_ERROR:
            return {
                ...state,
                timeLimits: {
                    ...state.timeLimits,
                    timeLimitLoading: false,
                }
            }
        case ActionType.GET_TIME_LIMIT_SUCCESS:
            return {
                ...state,
                timeLimits: {
                    data: action.payload,
                    timeLimitLoading: false,
                }
            }
        case ActionType.GET_DEPOSIT_LIMIT_BEGIN:
            return {
                ...state,
                depositLimits: {
                    ...state.depositLimits,
                    depositLimitLoading: true,
                }
            }
        case ActionType.GET_DEPOSIT_LIMIT_ERROR:
            return {
                ...state,
                depositLimits: {
                    ...state.depositLimits,
                    depositLimitLoading: false,
                }
            }
        case ActionType.GET_DEPOSIT_LIMIT_SUCCESS:
            return {
                ...state,
                depositLimits: {
                    data: action.payload,
                    depositLimitLoading: false,
                }
            }
        case ActionType.GET_BET_LIMIT_BEGIN:
            return {
                ...state,
                betLimits: {
                    ...state.betLimits,
                    betLimitLoading: true,
                }
            }
        case ActionType.GET_BET_LIMIT_ERROR:
            return {
                ...state,
                betLimits: {
                    ...state.betLimits,
                    betLimitLoading: false,
                }
            }
        case ActionType.GET_BET_LIMIT_SUCCESS:
            return {
                ...state,
                betLimits: {
                    data: action.payload,
                    betLimitLoading: false,
                }
            }
        case ActionType.GET_SINGLE_BET_BEGIN:
            return {
                ...state,
                singleBet: {
                    ...state.singleBet,
                    singleBetLoading: true,
                }
            }
        case ActionType.GET_SINGLE_BET_ERROR:
            return {
                ...state,
                singleBet: {
                    ...state.singleBet,
                    singleBetLoading: false,
                }
            }
        case ActionType.GET_SINGLE_BET_SUCCESS:
            return {
                ...state,
                singleBet: {
                    data: action.payload,
                    singleBetLoading: false,
                }
            }
        case ActionType.SET_SINGLE_BET_BEGIN:
            return {
                ...state,
                singleBet: {
                    ...state.singleBet,
                    singleBetLoading: true,
                }
            }
        case ActionType.SET_SINGLE_BET_ERROR:
            return {
                ...state,
                singleBet: {
                    ...state.singleBet,
                    singleBetLoading: false,
                }
            }
        case ActionType.SET_SINGLE_BET_SUCCESS:
            return {
                ...state,
                singleBet: {
                    data: action.payload,
                    singleBetLoading: false,
                }
            }
        case ActionType.GET_TIME_OUT_BEGIN:
            return {
                ...state,
                timeOut: {
                    ...state.timeOut,
                    isTimeOutLoading: true,
                }
            }
        case ActionType.GET_TIME_OUT_ERROR:
            return {
                ...state,
                timeOut: {
                    ...state.timeOut,
                    isTimeOutLoading: false,
                }
            }
        case ActionType.GET_TIME_OUT_SUCCESS:
            return {
                ...state,
                timeOut: {
                    data: action.payload,
                    isTimeOutLoading: false,
                }
            }
        case ActionType.GET_SELF_EXCLUSION_BEGIN:
            return {
                ...state,
                selfExclusion: {
                    ...state.selfExclusion,
                    isLoading: true,
                }
            }
        case ActionType.GET_SELF_EXCLUSION_ERROR:
            return {
                ...state,
                selfExclusion: {
                    ...state.selfExclusion,
                    isLoading: false,
                }
            }
        case ActionType.GET_SELF_EXCLUSION_SUCCESS:
            return {
                ...state,
                selfExclusion: {
                    data: action.payload,
                    isLoading: false,
                }
            }
        case ActionType.GET_EXCLUSION_REASONS_BEGIN:
            return {
                ...state,
                exclusionReasons: {
                    ...state.exclusionReasons,
                    loading: true
                }
            }
        case ActionType.GET_EXCLUSION_REASONS_ERROR:
            return {
                ...state,
                exclusionReasons: {
                    ...state.exclusionReasons,
                    loading: false
                }
            }
        case ActionType.GET_EXCLUSION_REASONS_SUCCESS:
            return {
                ...state,
                exclusionReasons: {
                    [action.section]: action.payload,
                    loading: false,
                }
            }

        case ActionType.GET_REALITY_CHECK_BEGIN:
            return {
                ...state,
                realityCheck: {
                    ...state.realityCheck,
                    isLoading: true
                }
            }
        case ActionType.GET_REALITY_CHECK_ERROR:
            return {
                ...state,
                realityCheck: {
                    ...state.realityCheck,
                    isLoading: false
                }
            }
        case ActionType.GET_REALITY_CHECK_SUCCESS:
            return {
                ...state,
                realityCheck: {
                    data: action.payload,
                    isLoading: false,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_BEGIN:
            return {
                ...state,
                accessLimits: {
                    ...state.accessLimits,
                    accessLimitsLoading: true,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_ERROR:
            return {
                ...state,
                accessLimits: {
                    ...state.accessLimits,
                    accessLimitsLoading: false,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_SUCCESS:
            return {
                ...state,
                accessLimits: {
                    data: action.payload,
                    accessLimitsLoading: false,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_OVERVIEW_BEGIN:
            return {
                ...state,
                accessLimitsOverview: {
                    ...state.accessLimitsOverview,
                    accessLimitLoading: true,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_OVERVIEW_ERROR:
            return {
                ...state,
                accessLimitsOverview: {
                    ...state.accessLimitsOverview,
                    accessLimitLoading: false,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_OVERVIEW_SUCCESS:
            return {
                ...state,
                accessLimitsOverview: {
                    data: action.payload,
                    accessLimitLoading: false,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_PENDING_BEGIN:
            return {
                ...state,
                accessLimitsPending: {
                    ...state.accessLimitsPending,
                    accessLimitLoading: true,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_PENDING_ERROR:
            return {
                ...state,
                accessLimitsPending: {
                    ...state.accessLimitsPending,
                    accessLimitLoading: false,
                }
            }
        case ActionType.GET_ACCESS_LIMIT_PENDING_SUCCESS:
            return {
                ...state,
                accessLimitsPending: {
                    data: action.payload,
                    accessLimitLoading: false,
                }
            }
        case ActionType.GET_LOSS_LIMIT_BEGIN:
            return {
                ...state,
                lossLimits: {
                    ...state.lossLimits,
                    lossLimitLoading: true,
                }
            }
        case ActionType.GET_LOSS_LIMIT_ERROR:
            return {
                ...state,
                lossLimits: {
                    ...state.lossLimits,
                    lossLimitLoading: false,
                }
            }
        case ActionType.GET_LOSS_LIMIT_SUCCESS:
            return {
                ...state,
                lossLimits: {
                    data: action.payload,
                    lossLimitLoading: false,
                }
            }
        case ActionType.SET_LOSS_LIMIT_BEGIN:
            return {
                ...state,
                lossLimits: {
                    ...state.lossLimits,
                    lossLimitLoading: true,
                }
            }
        case ActionType.SET_LOSS_LIMIT_ERROR:
            return {
                ...state,
                lossLimits: {
                    ...state.lossLimits,
                    lossLimitLoading: false,
                }
            }
        case ActionType.SET_LOSS_LIMIT_SUCCESS:
            return {
                ...state,
                lossLimits: {
                    data: action.payload,
                    lossLimitLoading: false,
                }
            }
        case ActionType.GET_APPLAY_PLAYER_PENDING_LIMIT_BEGIN:
            return {
                ...state,
                applayLimits: {
                    ...state.applayLimits,
                    isPlayerApplayLoading: true,
                }
                
            }
        case ActionType.GET_APPLAY_PLAYER_PENDING_LIMIT_SUCCESS:
            return {
                 ...state,
                applayLimits: {
                    data: action.payload,
                    isPlayerApplayLoading: false,
                }
            }

        case ActionType.GET_APPLAY_PLAYER_PENDING_LIMIT_ERROR:
            return {
                ...state,
                applayLimits: {
                    ...state.applayLimits,
                    isPlayerApplayLoading: false,
                }
                
            }
        default:
            return state;
    }

}

